import { classNames } from "@ember-decorators/component"
import { A } from "@ember/array"
import Component from "@ember/component"
import { action } from "@ember/object"
import { later, scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type { Card, CardGoogleClassroom } from "@shared/models/card-stack"
import type { AiValueEditor } from "cc-frontend/lib/ai/ai-value-editor"
import { LegacyGoogleClassroomCardEditor } from "cc-frontend/lib/google-classroom/legacy-card-editor"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import type ModalManager from "cc-frontend/services/modal-manager"
import SortableNode from "ember-sortable/mixins/sortable-node"
import { includes, sortBy } from "lodash-es"

@classNames("lesson-sections-sortable")
// @ts-ignore
export default class Cards extends Component.extend(SortableNode) {
  // arguments
  usedAs!: string
  cardStackId!: string
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  registerCardEditor?: (cardId: string, prop: string, editor: AiValueEditor<unknown>) => void
  permissions!: Array<string>
  isFullScreen!: boolean
  planbookId!: string
  courseId!: string
  dateString!: string
  sortedCards!: Array<Card>

  // services
  @service("ember-store") declare store: EmberStore
  @service declare lessonEditor: LessonEditor
  @service declare modalManager: ModalManager

  // state
  handle = ".js-move-button"
  sortableChildren = A([])
  canShowAddCardMenu: boolean = false
  addCardMenuConstraints = [
    {
      to: "window",
      pin: ["bottom"],
    },
  ]

  addSortableChild(child) {
    // Delay so we don't block render

    scheduleOnce("afterRender", this, () => {
      // @ts-ignore
      this.sortableChildren.addObject(child)
      this.sortableChildren = sortBy(
        this.sortableChildren,
        // @ts-ignore
        (child) => child.model.attributes.position
      )
    })
  }

  removeSortableChild(child) {
    // @ts-ignore
    this.sortableChildren.removeObject(child)
  }

  canReceiveSortable(_node) {
    return true
  }

  highlightMovingSection(movingSection) {
    let id = `#lesson-section-${movingSection.id}`
    // The reason we look up the element everytime is because it might not be in the dom at the start
    // of the method
    later(() => {
      // set(movingSection, "justMoved", true)
      $(id).addClass("just-moved")
      later(() => {
        // set(movingSection, "justMoved", false)
        $(id).removeClass("just-moved")
        later(() => {
          // set(movingSection, "justMoved", true)
          $(id).addClass("just-moved")
          later(() => {
            // set(movingSection, "justMoved", false)
            $(id).removeClass("just-moved")
          }, 750)
        }, 750)
      }, 750)
    }, 750)
  }

  @action
  beginMove() {
    $(":focus").blur()
    this.sortableChildren = sortBy(
      this.sortableChildren,
      // @ts-ignore
      (child) => child.model.attributes.position
    )
  }

  @action
  onMove(oldCardStackId, section, { newParent, receiverContext, position }) {
    let newCardStackId = receiverContext ? receiverContext.cardStackId : oldCardStackId
    this.lessonEditor.moveCard(
      this.modelsNeededForFirstEdit,
      section,
      oldCardStackId,
      newCardStackId,
      newParent,
      receiverContext,
      position
    )
    this.highlightMovingSection(section)
  }

  @action openGoogleClassroomPostSidebar(card: CardGoogleClassroom) {
    if (
      card.type === "card-google-classroom" &&
      this.usedAs === "lesson" &&
      includes(this.permissions, "can-edit-plan")
    ) {
      if (document && document.activeElement) (document.activeElement as HTMLElement).blur()
      this.store.find("planbook", this.planbookId).then((planbook) => {
        this.modalManager.openModal("planner/modals/google-classroom", {
          cardEditor: new LegacyGoogleClassroomCardEditor({
            store: this.store,
            lessonEditor: this.lessonEditor,
            modelsNeededForFirstEdit: this.modelsNeededForFirstEdit,
            cardStackId: this.cardStackId,
            cardId: card.id,
            dateString: this.dateString,
          }),
          dateString: this.dateString,
          cardStackId: this.cardStackId,
          planbook: planbook,
        })
      })
    }
  }
}
